__turbopack_context__.v({
  "className": "fraunces_e44b662a-module__-zBQGW__className",
  "variable": "fraunces_e44b662a-module__-zBQGW__variable",
});
